// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"221":"0ce7cba2","346":"1a6ac532","903":"38b5f45c"}[chunkId] + ".chunk.js";
};